import { computed, ref } from 'vue'

import { useExplorerStore } from '@/features/explorer/store'
import { isFile } from '@/features/explorer/utils/itemGuards'

const selectedIds = ref<string[]>([])

export function useExplorerSelection() {
  const explorerStore = useExplorerStore()

  const selectedItems = computed(() =>
    (explorerStore.currentFolder?.items ?? []).filter((item) =>
      selectedIds.value.includes(item.id)
    )
  )

  const selectedFiles = computed(() => selectedItems.value.filter(isFile))

  const isSelected = (id: string) => selectedIds.value.includes(id)

  const setSelected = (ids: string[]) => {
    selectedIds.value = ids
  }

  const clear = () => {
    selectedIds.value = []
  }

  const toggle = (id: string) => {
    selectedIds.value = isSelected(id)
      ? selectedIds.value.filter((value) => value !== id)
      : [...selectedIds.value, id]
  }

  return {
    selectedIds,
    selectedItems,
    selectedFiles,
    isSelected,
    setSelected,
    toggle,
    clear,
  }
}
